import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/App";
import { toast } from "sonner";
import { Loader2, Film } from "lucide-react";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back, Ryan");
      navigate("/");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Invalid credentials");
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-[#0f1114] flex items-center justify-center px-4">
      <div className="w-full max-w-sm">
        <div className="text-center mb-10">
          <div className="inline-flex items-center justify-center w-14 h-14 rounded-2xl bg-studio-raised border border-[#2a2e36] mb-5">
            <Film size={28} className="text-gold" />
          </div>
          <h1 className="font-display text-3xl font-bold text-zinc-100">CommandPost</h1>
          <p className="section-label mt-3">// social media command center</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4" data-testid="login-form">
          <div>
            <label className="section-label block mb-2">// email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full h-12 px-4 bg-studio-surface border border-[#2a2e36] rounded-xl text-zinc-200 text-sm outline-none focus:border-gold-dim transition-colors placeholder:text-zinc-600"
              placeholder="ryan.geldermann@gmail.com"
              required
              data-testid="login-email-input"
            />
          </div>
          <div>
            <label className="section-label block mb-2">// password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full h-12 px-4 bg-studio-surface border border-[#2a2e36] rounded-xl text-zinc-200 text-sm outline-none focus:border-gold-dim transition-colors placeholder:text-zinc-600"
              placeholder="Enter password"
              required
              data-testid="login-password-input"
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            className="btn-gold w-full h-12 rounded-xl text-sm font-semibold flex items-center justify-center gap-2 disabled:opacity-60"
            data-testid="login-submit-btn"
          >
            {loading ? <Loader2 size={18} className="animate-spin" /> : null}
            {loading ? "Signing in..." : "Enter CommandPost"}
          </button>
        </form>

        <p className="text-center text-zinc-600 text-xs mt-8 font-mono">
          v1.0.0 -- personal tool -- Ryan Geldermann
        </p>
      </div>
    </div>
  );
}
